export default __webpack_public_path__ + "maps-examples-show-hide-layer-1200-6689ef5d73dd53178b6e2ee3f40e2eea.webp";